import { render, staticRenderFns } from "./ShopPublic.vue?vue&type=template&id=ce6d1fd8&scoped=true&"
import script from "./ShopPublic.vue?vue&type=script&lang=js&"
export * from "./ShopPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6d1fd8",
  null
  
)

export default component.exports